// Cloudflare Image Resizing helper.
//
// Rewrites R2-hosted image URLs through Cloudflare's /cdn-cgi/image/ transform
// endpoint so each device downloads an appropriately-sized, auto-format
// (WebP/AVIF) variant instead of the full-resolution original — a big win on
// slow/metered connections.
//
// Gated behind NEXT_PUBLIC_CF_IMAGE_RESIZE='1'. It's a NO-OP (returns the
// original URL) until you've put the R2 public domain behind a Cloudflare zone
// with Image Resizing enabled — otherwise the /cdn-cgi/image/ path would 404.
// Even when disabled, SmartImage still adds lazy-loading + async decode.

const R2_BASE = (process.env.NEXT_PUBLIC_R2_PUBLIC_URL || '').replace(/\/+$/, '');
const ENABLED = process.env.NEXT_PUBLIC_CF_IMAGE_RESIZE === '1' && !!R2_BASE;

const NON_IMAGE_RE = /\.(mp4|mov|webm|ogg|avi|m3u8|gif|svg)(\?|$)/i;

export function isResizeEnabled() {
  return ENABLED;
}

// Only rewrite our own R2 raster images (never videos, gifs, svgs, or
// already-transformed URLs).
function rewritable(url) {
  return (
    ENABLED &&
    typeof url === 'string' &&
    url.startsWith(`${R2_BASE}/`) &&
    !NON_IMAGE_RE.test(url) &&
    !url.includes('/cdn-cgi/image/')
  );
}

export function resizedUrl(url, { width, quality = 80, fit = 'cover' } = {}) {
  if (!rewritable(url) || !width) return url;
  const path = url.slice(R2_BASE.length); // leading "/key.ext"
  const opts = [`width=${Math.round(width)}`, `quality=${quality}`, `fit=${fit}`, 'format=auto'].join(',');
  return `${R2_BASE}/cdn-cgi/image/${opts}${path}`;
}

export function buildSrcSet(url, widths, quality = 80) {
  if (!rewritable(url)) return undefined;
  return widths.map((w) => `${resizedUrl(url, { width: w, quality })} ${w}w`).join(', ');
}
